module.exports = __webpack_public_path__ + "img/deviceFr.63256779.png";